import {Button, TableCell, TableRow} from "@mui/material";
import * as React from "react";
import {TicketLogEntry} from "../../interfaces/processing";
import {Add} from "@mui/icons-material";
import {Link as RouterLink} from "react-router-dom";

interface TicketLogRowProps {
  ticketLogEntry: TicketLogEntry
  isAdmin?: boolean
}

export default function TicketLogRow({ticketLogEntry, isAdmin = false}: TicketLogRowProps) {
  const createdDate = new Date(ticketLogEntry.created_at);

  const viewLink = isAdmin ? `/admin/processing-entry/${ticketLogEntry.id}/${ticketLogEntry.user_id}` : `/processing-entry/${ticketLogEntry.id}`;

  return (
    <TableRow
      sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
      hover
    >
      <TableCell component="th" scope="row">
        {ticketLogEntry.external_id}
      </TableCell>
      <TableCell>
        {ticketLogEntry.ticket_status === 'bug' &&
          <div style={{
            color: 'red'
          }}>
            <b>Bug</b>
          </div>}

        {ticketLogEntry.ticket_status === 'bug-testing' &&
          <div style={{
            color: 'green'
          }}>
            <b>Ready for testing</b>
          </div>}
      </TableCell>
      <TableCell>
        {(ticketLogEntry.ticket_status === 'bug' || ticketLogEntry.ticket_status === 'bug-testing') && <div>
          {ticketLogEntry.bug_severity === 1 && <div
            style={{
              color: 'black',
              padding: '10px 20px',
              borderRadius: '5px',
              backgroundColor: '#f1cf00',
              width: '100px',
              textAlign: 'center'
            }}
          >
            <b>Low</b>
          </div>}
          {ticketLogEntry.bug_severity === 2 && <div
            style={{
              color: 'white',
              padding: '10px 20px',
              borderRadius: '5px',
              backgroundColor: '#f16400',
              width: '100px',
              textAlign: 'center'
            }}
          >
            Medium
          </div>}
          {ticketLogEntry.bug_severity === 3 && <div
            style={{
              color: 'white',
              padding: '10px 20px',
              borderRadius: '5px',
              backgroundColor: '#f10000',
              width: '100px',
              textAlign: 'center'
            }}
          >
            High
          </div>}
        </div>}
      </TableCell>
      <TableCell component="th" scope="row">
        {ticketLogEntry.has_auto_tests ? 'Yes' : ''}
      </TableCell>
      <TableCell >{createdDate.toDateString()} {createdDate.toLocaleTimeString()}</TableCell>
      <TableCell >
        <RouterLink to={viewLink}>
          <Button onClick={() => {
          }} startIcon={<Add/>} variant="contained">
            View Processing Entry
          </Button>
        </RouterLink>
      </TableCell>
    </TableRow>
  )
}
